import ThreeDotsHorizontalIcon from "@redotech/redo-icons/dots-horizontal.svg";
import { JSXElementConstructor, memo, useState } from "react";
import {
  RedoCommandMenu,
  RedoCommandMenuItem,
} from "../command-menu/redo-command-menu";
import * as redoListItemCss from "./redo-list-item.module.css";

export const RedoListItemCommandMenu = memo(function RedoListItemCommandMenu({
  disabled,
  menu,
  open,
  setOpen,
  "data-dd-action-name": actionName,
}: {
  "data-dd-action-name"?: string;
  disabled: boolean;
  menu:
    | RedoCommandMenuItem[]
    | { onClick: () => void; Icon?: JSXElementConstructor<any> };
  open: boolean;
  setOpen(value: boolean): void;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const isCommandMenu = Array.isArray(menu);
  // Single-action buttons may override the icon; the command-menu variant and
  // the default both use the three-dot glyph.
  const Icon =
    !isCommandMenu && menu.Icon ? menu.Icon : ThreeDotsHorizontalIcon;

  return (
    <>
      <button
        className={redoListItemCss.menu}
        data-arbiter="RedoListItemCommandMenu"
        data-dd-action-name={actionName}
        disabled={disabled}
        onClick={(event) => {
          if (!disabled) {
            event.stopPropagation();
            if (isCommandMenu) {
              setOpen(!open);
            } else {
              menu.onClick();
            }
          }
        }}
        ref={setAnchor}
      >
        <Icon />
      </button>

      {isCommandMenu && (
        <RedoCommandMenu
          anchor={anchor}
          items={menu}
          open={open}
          setOpen={setOpen}
          size="xs"
        />
      )}
    </>
  );
});
